import React, { useEffect } from 'react';
import './Lightbox.css';

const Lightbox = ({ image, caption, onClose }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && image) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [image, onClose]);

  if (!image) return null;

  return (
    <div className="lightbox active" onClick={onClose}>
      <span className="lightbox-close" onClick={onClose}>&times;</span>
      <img className="lightbox-content" src={image} alt={caption} onClick={(e) => e.stopPropagation()} />
      {caption && <div className="lightbox-caption">{caption}</div>}
    </div>
  );
};

export default Lightbox;